{
  /* <SymptomIcon
symptom={symptom}
className="h-6 w-6 mr-1"
/> */
}

{
  /* <img
className={clsx(className)}
src={focus.icon}
alt={focus.name}
{...props}
/> */
}

const Icons = {
  //nourishing
  all: `https://cdn.shopify.com/s/files/1/0467/2841/3334/files/Flavorful-Nourishing.svg?v=1740603496`,
  //hormone balance
  "hormone balance": `https://cdn.shopify.com/s/files/1/0467/2841/3334/files/Hormone-Balance.svg?v=1740603587`,
  //fertility
  fertility: `https://cdn.shopify.com/s/files/1/0467/2841/3334/files/Fertility.svg?v=1740603482`,
  //prenatal
  prenatal: `https://cdn.shopify.com/s/files/1/0467/2841/3334/files/Prenatal.svg?v=1740603707`,
  //postpartum
  postpartum: `https://cdn.shopify.com/s/files/1/0467/2841/3334/files/Postpartum.svg?v=1740603701`,
  //diagnosis
  diagnosis: `https://cdn.shopify.com/s/files/1/0467/2841/3334/files/diagnosis.svg?v=1740603911`,
  //mental health
  "mental health": `https://cdn.shopify.com/s/files/1/0467/2841/3334/files/Mood-Energy.svg?v=1740603619`,
};

const availableTags = ['hormone-balance', 'fertility', 'prenatal', 'postpartum', 'diagnosis', 'mental health']; 

const defaultColor = "#531e44";
const defaultAriaHidden = true;
const defaultIconTabIndex = "-1";
const defaultIconRole = "presentation";

const getIcons = (
  category
  //   iconColor = defaultColor,
  //   iconAriaHidden = defaultAriaHidden,
  //   iconTabIndex = defaultIconTabIndex,
  //   iconRole = defaultIconRole,
) => {
  let icon = Icons[`${category}`];
  return icon;
};

document.addEventListener("DOMContentLoaded", function () {
  const apiURL = `https://api.wearechiyo.com/api/v1/articles/blog`;
  //const apiURL = `http://localhost:3333/api/v1/articles/blog` //for testing
  const filterButtons = document.querySelectorAll(".blog-tag__filter-items");
  const articleContainer = document.getElementById("article-container");
  const errorContainer = document.getElementById("no-article-data");
  const showMoreBtn = document.getElementById("show-more-btn");
  let nextCursor = null; // Pagination cursor
  //   let currentBlog = "knowledge"; // Default blog handle

  const urlParts = window.location.pathname.split("/").filter(Boolean);
  let currentBlog = urlParts.includes("blogs")
    ? urlParts[urlParts.indexOf("blogs") + 1]
    : null;

  if (currentBlog) {
    //console.log("Current Blog:", currentBlog);
  } else {
    console.warn("Blog name could not be determined from the URL.");
  }

  // Extract tag from URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  let currentTag = urlParams.get("tag");

  // Validate if currentTag exists in one of the dataset-tag values
  let validTags = Array.from(filterButtons).map((button) => button.dataset.tag);
  if (!currentTag || !validTags.includes(currentTag)) {
    currentTag = "all"; // Default tag
  }

  // Set active class based on the tag
  filterButtons.forEach((button) => {
    if (button.dataset.tag === currentTag) {
      button.classList.add("active");
    } else {
      button.classList.remove("active");
    }
  });

  async function fetchAllArticles(blog, tag, append = false) {
    let url = `${apiURL}/${encodeURIComponent(blog)}`;
    if (nextCursor) {
      url += `?cursor=${encodeURIComponent(nextCursor)}`;
    }

    try {
      const response = await fetch(url);

      const data = await response.json();

      if (!data?.edges || data?.edges?.length === 0) {
        console.warn("No articles found.");
        errorContainer.classList.add("active");
        return;
      }

      if (!append) {
        articleContainer.innerHTML = ""; // Clear previous articles
      }

      data.edges.forEach(({ node }) => {
        const articleHtml = generateHtml(node, tag);
        articleContainer.insertAdjacentHTML("beforeend", articleHtml);
      });

      // Handle pagination
      if (data?.pageInfo?.hasNextPage === true) {
        nextCursor = data.pageInfo.endCursor;
        showMoreBtn.classList.remove("hidden");
      } else {
        showMoreBtn.classList.add("hidden");
      }
    } catch (error) {
      errorContainer.classList.add("active");
      console.error("Error fetching articles:", error);
    }
  }

  async function fetchArticles(blog, tag, append = false) {
    let url = `${apiURL}/${encodeURIComponent(blog)}/${encodeURIComponent(
      tag
    )}`;
    if (nextCursor) {
      url += `?cursor=${encodeURIComponent(nextCursor)}`;
    }

    try {
      const response = await fetch(url);

      const data = await response.json();

      if (!data?.edges || data?.edges?.length === 0) {
        errorContainer.classList.add("active");
        console.warn("No articles found.");
        return;
      }

      if (!append) {
        articleContainer.innerHTML = ""; // Clear previous articles
      }

      data.edges.forEach(({ node }) => {
        const articleHtml = generateHtml(node, tag);
        articleContainer.insertAdjacentHTML("beforeend", articleHtml);
      });

      // Handle pagination
      if (data?.pageInfo?.hasNextPage === true) {
        nextCursor = data.pageInfo.endCursor;
        showMoreBtn.classList.remove("hidden");
      } else {
        showMoreBtn.classList.add("hidden");
      }
    } catch (error) {
      errorContainer.classList.add("active");
      console.error("Error fetching articles:", error);
    }
  }

  function generateHtml(node, tag) {
    const cleansedTag = tag.toLowerCase().split("-").join(" ");
    console.log(cleansedTag);
    console.log(node?.tags);
    
    const tagDisplayed =
      tag !== "all"
        ? node?.tags?.filter((t) => t.toLowerCase() === cleansedTag)
        : node?.tags?.filter((t) => availableTags.includes(t.toLowerCase())) || [];

    const icon =
      tagDisplayed.length > 0
        ? getIcons(tagDisplayed[0].toLowerCase())
        : getIcons("all");
    const articleHtml = `

          <div class="article-card"> 
   
          <a>
            <div class="article-image">
      
              ${
                node.image
                  ? `<img src="${node.image.originalSrc}" alt="${
                      node.image.altText || ""
                    }">`
                  : ""
              }
              
            </div>
            </a>
    
            <div class="article-content">
                 <div class="article-content-copy">
                    <h3><a href="${node.onlineStoreUrl}" target="_blank">${node.title}</a></h3>
                    <p>${node?.excerpt?.length > 0 ? node?.excerpt : ""}</p>
                 </div>
  
              <div class="article-details">

              ${tagDisplayed?.length > 0 && 
                `<div class="article-tag"><span class="text">${tagDisplayed[0]}</span><img src="${icon}" width="24" height="24"/></div>`
              }
              </div>
            </div>
          </div>
        `;

    return articleHtml;
  }

  // Handle filter button click
  filterButtons.forEach((button) => {
    button.addEventListener("click", function () {
      // Remove "active" class from all buttons
      filterButtons.forEach((btn) => btn.classList.remove("active"));
      // Add "active" class to the clicked button
      this.classList.add("active");
      // Update the current tag and reset pagination
      currentTag = this.dataset.tag;
      nextCursor = null;
      if (currentTag === "all") {
        fetchAllArticles(currentBlog, currentTag);
      } else {
        fetchArticles(currentBlog, currentTag);
      }
    });
  });

  // Handle "Show More" button click
  showMoreBtn.addEventListener("click", function () {
    if (currentTag === "all") {
      fetchAllArticles(currentBlog, currentTag, true);
    } else {
      fetchArticles(currentBlog, currentTag, true);
    }
  });

  // Load initial articles
  if (currentBlog && currentTag) {
    if (currentTag === "all") {
      errorContainer.classList.remove("active");
      fetchAllArticles(currentBlog, currentTag);
    } else {
      errorContainer.classList.remove("active");
      fetchArticles(currentBlog, currentTag);
    }
  }
});
